import { createReducer } from '@reduxjs/toolkit';

import * as actions from './actions';
import { initialState } from './initialState';

/**
 * Auth reducer
 */
const authReducer = createReducer(initialState, builder => {
  builder
    // Session actions
    .addCase(actions.setUser, (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
    })
    // Logout actions
    .addCase(actions.clearAuth, state => {
      state.user = null;
      state.isAuthenticated = false;
    });
});

export default authReducer;
